import React, { useState, useEffect } from 'react';
import '../styles/pricing.css';
import AR from "../../src/data/ar.json"
import EN from "../../src/data/en.json"
import { buildPlatformSignUpUrl } from "../utils/publicFarmPreview";
import { BlurFade } from './ui/BlurFade';
import emailjs from "emailjs-com";

export const PricingPlansSection = ({ lang }) => {
  const [activeTab, setActiveTab] = useState('6Months');

  /****** Localized strings — all sourced from JSON. Tier detection uses the
   *      stable `tier` field on each plan, not the display name, so editing
   *      the rendered copy never breaks Enterprise/Free branching.            */
  const Common = lang === "EN" ? EN.common : AR.common;
  const pricing = Common.pricing;
  const form = Common.quoteForm;
  const Data = lang === "EN" ? EN.Plans : AR.Plans;
  const pricingPlans = Data.plan;
  const plans = pricingPlans[activeTab];

  /***** Email form state */
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    Arcs: "",
    frames: "",
    Farmed: "",
    company: ""
  });

  const [status, setStatus] = useState(""); // For form submission status

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const [isOpen, setIsOpen] = useState(false); // Manage popup visibility

  // Toggle popup visibility
  const togglePopup = () => {
    setIsOpen(!isOpen);
  };
  const handleSubmit = (e) => {
    e.preventDefault();


    emailjs
      .send(
        "service_96zhono", "template_ahar09d",
        formData,
        "ljvsv9MvB5zs8pTXb"
      )
      .then(
        (response) => {
          console.log("SUCCESS!", response.status, response.text);
          setStatus("SUCCESS");
          setFormData({ name: "", email: "", phone: "", Arcs: "", frames: "", Farmed: "", company: "" }); // Reset the form
          togglePopup();
        },
        (error) => {
          console.error("FAILED...", error);
          setStatus("FAILED");
        }
      );
  };
  /***End Email */
  const getUserCountry = async () => {
    try {
      const response = await fetch('https://geolocation-db.com/json/');
      const data = await response.json();
      return data.country_code;
    } catch (error) {
      console.error('Error fetching location data:', error);
      return null;
    }
  };

  const [currency, setCurrency] = useState("USD");

  useEffect(() => {
    const fetchCurrency = async () => {
      const country = await getUserCountry();
      setCurrency(country === 'EG' ? "EGP" : "USD");
    };

    fetchCurrency();
  }, []);

  /****** {End Vars} */
  return (
    <section id="pricing-plan" className="d-flex justify-content-center align-items-center min-vh-100 py-5">
      <div>
        {/* Heading */}
        <BlurFade delay={0.25} inView>
          <h2 className="mb-4 text-center">{Data.title}<span className="text-success">{Data.greenTitle} </span></h2>
        </BlurFade>
        <BlurFade delay={0.25 * 2} inView>
          <p className="mb-4 text-center section-subtitle">{Data.paragraph}</p>
        </BlurFade>

        {/* Tabs for pricing intervals */}
        <div className="d-flex justify-content-center mb-2">
          <ul className="nav nav-tabs">
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === '6Months' ? 'active' : ''}`}
                onClick={() => setActiveTab('6Months')}
              >
                {pricing.tabSixMonths}
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === '1year' ? 'active' : ''}`}
                onClick={() => setActiveTab('1year')}
              >
                {pricing.tabOneYear} <span className='badge badge-success'>10%</span>
              </button>
            </li>
          </ul>
        </div>

        {/* Billing-cycle clarification — the displayed price is per-month and
            applies under a 6-month (or 1-year) commitment. Without this, the
            "/Month" suffix under a "6 Months" or "1 Year" tab is ambiguous. */}
        <p className="text-center text-muted mb-4" style={{ fontSize: "85%" }}>
          {pricing.billingNote}
        </p>

        {/* Pricing Plans */}
        <div className="row price-row justify-content-center">
          {plans.map((plan, index) => {
            const isEnterprise = plan.tier === "enterprise";
            const isFree = plan.tier === "free";
            const priceLabelColor = isEnterprise ? "text-warning" : "text-success";
            return (
              <div key={index} className="col-md-3 col-sm-12 mb-3">
                <div className="cardP h-100 shadow">
                  <div className="card-bodyP">
                    <h5 className={`text-center text-uppercase ${priceLabelColor}`}>{plan.name}</h5>
                    <h2 className="card-price text-center">
                      <small className="text-muted" style={{ fontSize: "50%" }}>
                        {isEnterprise ? pricing.startFrom : ""}
                      </small>
                      {currency === "USD" ? "$" + plan.priceG : plan.priceE}
                      <small className="text-muted" style={{ fontSize: "50%" }}>
                        {" "}
                        {currency === "USD" ? "" : pricing.currencyDisplay}/ {pricing.monthSuffix}
                      </small>
                      {isEnterprise ? (
                        <small className="text-muted" style={{ fontSize: "50%" }}>/ {pricing.acreSuffix}</small>
                      ) : ""}
                    </h2>
                    <ul className={`list-unstyled ${lang === "EN" ? "pricing-card" : "pricing-card-ar"} mt-3 mb-4`}>
                      {plan.listBenefits.map((feature, i) => (
                        <li key={i} className="d-flex align-items-center">
                          <svg width="12" height="8" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.70704 11.8903C6.41354 11.7801 6.12062 11.7801 5.89648 11.5592L0.5 6.23992L2.12112 4.64142L6.70704 9.16174L15.8789 0.121094L17.5 1.71959L7.5176 11.5592C7.29347 11.7801 7.00054 11.8903 6.70704 11.8903Z" fill="#68D585" />
                          </svg>
                          {feature}
                        </li>
                      ))}
                    </ul>
                    {isEnterprise ? (
                      <button type="button" onClick={togglePopup} className={`btn btn-warning btn-block`}>
                        {pricing.btnEnterprise}
                      </button>
                    ) : (
                      <a href={buildPlatformSignUpUrl()} className={`btn btn-success btn-block`}>
                        {isFree ? pricing.btnFree : pricing.btnSelect}
                      </a>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Popup Modal */}
      {isOpen && (
        <div className="fixedcta inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" dir={lang === "EN" ? "ltr" : "rtl"}>
          <div className="bg-white p-6 rounded-lg shadow-lg w-98">
            <h2 className="text-xl font-bold mb-4 text-center">{form.title}</h2>

            {/* Form */}
            <form onSubmit={handleSubmit} className={` ${lang === "EN" ? "" : "ar"}`} dir={lang === "EN" ? "ltr" : "rtl"}>
              <div className="mb-4 col-md-6">
                <label className={`block text-sm font-medium mb-1 ${lang === "EN" ? "" : "ar"}`}>{form.name}:</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md"
                />
              </div>
              <div className="mb-4 col-md-6">
                <label className={`block text-sm font-medium mb-1 ${lang === "EN" ? "" : "ar"}`}>{form.phone}:</label>
                <input
                  type="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md"
                />
              </div>
              <div className="mb-4">
                <label className={`block text-sm font-medium mb-1 ${lang === "EN" ? "" : "ar"}`}>{form.email}:</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md"
                />
              </div>

              <div className="mb-4 col-md-6">
                <label className={`block text-sm font-medium mb-1 ${lang === "EN" ? "" : "ar"}`}>{form.farms}:</label>
                <input
                  type="Number"
                  name="farms"
                  value={formData.farms}
                  onChange={handleChange}
                  min={0}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md"
                />
              </div>

              <div className="mb-4 col-md-6">
                <label className={`block text-sm font-medium mb-1 ${lang === "EN" ? "" : "ar"}`}>{form.arcs}:</label>
                <input
                  type="Number"
                  name="Arcs"
                  value={formData.Arcs}
                  onChange={handleChange}
                  min={0}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md"
                />
              </div>
              <div className="mb-4">
                <label className={`block text-sm font-medium mb-1 ${lang === "EN" ? "" : "ar"}`}>{form.cropsFarmed}:</label>
                <input
                  type="Number"
                  name="Farmed"
                  value={formData.Farmed}
                  onChange={handleChange}
                  min={0}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md"
                />
              </div>
              <div className="mb-4">
                <label className={`block text-sm font-medium mb-1 ${lang === "EN" ? "" : "ar"}`}>{form.company}:</label>
                <input
                  type="Number"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  min={0}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md"
                />
              </div>
              <button
                type="submit"
                className="bg-green-500 m-2 text-white px-4 py-2 rounded-md"
              >
                {form.submit}
              </button>
              <button
                onClick={togglePopup}
                className="bg-gray-500 m-2 text-white px-4 py-2 rounded-md"
              >
                {form.close}
              </button>
            </form>

            {/* Submission Status */}
            {status === "SUCCESS" && (
              <p className="text-green-500 mt-2">{form.success}</p>
            )}
            {status === "FAILED" && (
              <p className="text-red-500 mt-2">{form.fail}</p>
            )}
          </div>
        </div>
      )}
    </section>
  );
};
